import ReactPixel from 'react-facebook-pixel'
import TagManager from 'react-gtm-module'

const InitPixel = () => {
    const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
    }
    ReactPixel.init('2227287970854015', options)
}

const InitGTM = () => {
    const tagManagerArgs = {
        gtmId: 'GTM-KLB4GP7',
    }
    TagManager.initialize(tagManagerArgs)
}

const PageView = (view, title) => {
    if (
        window.location.host.includes('dev') ||
        window.location.host.includes('rec') ||
        window.location.host.includes('local')
    ) {
        return
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: 'me.pageView.' + view,
        'me.pageView.dp': '/tunnelmobile/?view=' + view,
    })
    ReactPixel.pageView()
}

const Event = (id, event) => {
    if (
        window.location.host.includes('dev') ||
        window.location.host.includes('rec') ||
        window.location.host.includes('local')
    ) {
        return
    }
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: event,
        'me.click.option': id,
    })
}

const PixelTrack = (data) => {
    if (
        window.location.host.includes('dev') ||
        window.location.host.includes('rec') ||
        window.location.host.includes('local')
    ) {
        return
    }
    ReactPixel.track(data)
}

export { PageView, Event, PixelTrack, InitPixel, InitGTM }
